/**
 * Created by senani on 12/18/18.
 */

import React, {Component, Fragment} from "react";
import "./CartTable.css";
import CartRow from "../CartRow/CartRow";
import CartHeader from "../CartHeader/CartHeader";
import CartBottom from "../CartBottom/CartBottom";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import PriceLoadingImage from "../../../../assets/img/loading_price.gif";
import CartPagination from "../CartPagination";
import Pagination from "react-js-pagination";


class CartTable extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>

                    <Fragment>
                        {this.props.cartItems.length===0 ?
                            <div>
                                <div className="spacer"></div>
                                <div>
                                    <h4 className="text-align-center">見積情報がございません。</h4>
                                    <button className="btn btn-md " id="cart-quote-btn"><Link to='/quotation/pcb'><text id="last-btn-txt">見積りスタート</text></Link></button>
                                </div>
                                <div className="spacer"></div>
                                <div className="spacer"></div>
                            </div> :
                            <div>
                                <CartHeader
                                    cartItems = {this.props.cartItems}
                                    checkedItems = {this.props.checkedItems}
                                    toggleAllItems={this.props.toggleAllItems}
                                    allChecked={this.props.allChecked}
                                />
                                {this.props.cartItems.map(item => {
                                    return <CartRow key={item.id}
                                                    items={item}
                                                    userId = {this.props.userId}
                                                    getCartItems={this.props.getCartItems}
                                                    fileKey = {this.props.fileKey}
                                                    checkedItems = {this.props.checkedItems}
                                                    toggleItem={this.props.toggleItem}
                                                    onCartItemDeleted = {this.props.onCartItemDeleted}
                                                    reviewResult = {item.reviewResult}
                                    />
                                })}

                                <div className="cart-item-pagination">
                                    <CartPagination
                                        activePage={this.props.activePage}
                                        itemsCountPerPage={this.props.itemsCountPerPage}
                                        totalItemsCount={this.props.totalItemsCount}
                                        handlePageChange={this.props.handlePageChange}
                                    />
                                </div>
                            </div>
                        }
                    </Fragment>


            </div>
        )
    }
}

export default CartTable;




// WEBPACK FOOTER //
// ./src/components/Site/Cart/CartTable/CartTable.js